import { Children, FC, ReactNode, SyntheticEvent, useCallback, useEffect, useRef, useState } from 'react';
import { useAtomValue } from 'jotai';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { StepScrollUI } from '~/components/step-scroll-ui';

import './style.scss';

interface StepScrollProps {
  className?: string;
  children?: ReactNode;
}

export const StepScroll: FC<StepScrollProps> = (props) => {
  const { children, className } = props;
  const { isMobile } = useAtomValue($UserAgent);

  const isPC = !isMobile;

  const scrollList = useRef<HTMLDivElement>(null);
  const childWidth = useRef<number>(0);

  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  // children 变化时，计算第一个child的宽度作为滚动步幅
  useEffect(() => {
    if (!scrollList.current) {
      return;
    }
    const item = scrollList.current.children.item(0);
    if (item) {
      childWidth.current = item.clientWidth;
    }

    const { scrollLeft, scrollWidth, clientWidth } = scrollList.current;
    setShowRight(scrollLeft < scrollWidth - clientWidth);
  }, [scrollList.current, children]);

  // 滚动时计算是否需要展示左右进度按钮
  const handleScroll = useCallback((e: SyntheticEvent<HTMLDivElement>) => {
    const div = e.target as HTMLDivElement;
    const { scrollLeft, scrollWidth, clientWidth } = div;

    setShowLeft(scrollLeft > 0);
    setShowRight(scrollLeft < scrollWidth - clientWidth);
  }, []);

  const handleActionClick = useCallback(
    (type: 'left' | 'right') => (event: SyntheticEvent) => {
      event.preventDefault();
      const atom = type === 'left' ? -1 : 1;
      scrollList.current?.scrollBy({ left: atom * childWidth.current });
    },
    [],
  );

  if (Children.toArray(children).length === 0) {
    return null;
  }

  return (
    <StepScrollUI
      className={className}
      left={showLeft}
      right={showRight}
      onClickLeft={handleActionClick('left')}
      onClickRight={handleActionClick('right')}
    >
      <div className="step-scroll-bar-list" ref={scrollList} onScroll={isPC ? handleScroll : undefined}>
        {children}
      </div>
    </StepScrollUI>
  );
};
